//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PendenciaNegociacao from './PendenciaNegociacao';
import Apuracao from './Apuracao';
import PendenciaApuracao from './PendenciaApuracao';
import ListarEvidencia from './ListarEvidencia';

export default {
  name: 'Pendencias',
  components: {
    ListarEvidencia,
    PendenciaApuracao,
    PendenciaNegociacao,
  },
  props: {
    pendencias: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dashboardApuracaoResources: this.$api.dashboardApuracao(this.$resource),
      dialog: false,
      page: 1,
      pendencia: null,
    };
  },
  watch: {
    page(val) {
      this.preencherPendencias(val);
    },
    dialog(val) {
      if (val) {
        this.page = 1;
        this.preencherPendencias(this.page);
      } else {
        this.$emit('Pendencias_close');
      }
    },
  },
  computed: {
    ultimaPagina() {
      return this.page === this.pendencias.length;
    },
  },
  methods: {
    irProximaApuracao() {
      this.page = this.page + 1;
    },
    preencherPendencias(page) {
      const ids = this.pendencias[page - 1];

      this.dashboardApuracaoResources.apuracao({ id: ids.id })
        .then((response) => {
          this.pendencia = new Apuracao(this.$t('title.negociacao'), ids.id, ids.idAcordo, response.data);
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/apuracao/pendencias/Pendencias.vue?vue&type=script&lang=js&